export const objGetProp = (obj, propPath) =>
  propPath
    .split('.')
    .reduce(
      (objInstance, prop) => (objInstance && objInstance[prop] ? objInstance[prop] : undefined),
      obj
    );
export const isDefined = (value) => value !== undefined && value !== null;
